angular.module('homebot.directives')
  .directive('sectionLoader', function(){
    return {
      restrict: 'E',
      controllerAs: 'loaderCtrl',
      bindToController: {
        loading: '=',
        content: '@',
      },
      scope: {},
      templateUrl: '/homes/templates/partials/section-loader.html',
      controller: function(){
        let ctrl = this;
      },
      link: function ($scope, el, attrs) {

      }
    }
  });
